//==============================================================================
// Class Name Helper
//
// Tool to standardize CSS class naming in module components and elements
//==============================================================================

export function clsHelper(baseClass: string, fragment?: string, separator: string = '__'): string | undefined {
    return fragment ? `${baseClass}${separator}${fragment}` : undefined;
}
